import { Link } from 'react-router-dom';
import { Sparkles, Lock, ArrowRight } from 'lucide-react';

import { Navbar } from '../../../components/Navbar.jsx';
import { LoginForm } from './LoginForm.jsx';

// --- FONDO AMBIENTAL ---
const AmbientBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-[#020202]">
    <div className="absolute top-[-10%] left-[20%] w-[60vw] h-[60vw] bg-indigo-900/20 rounded-full blur-[150px] opacity-30 mix-blend-screen animate-pulse" />
    <div className="absolute bottom-[-10%] right-[20%] w-[50vw] h-[50vw] bg-violet-900/10 rounded-full blur-[150px] opacity-20 mix-blend-screen" />
  </div>
);

export function LoginPage() {
  return (
    <div className="h-screen w-full text-slate-200 font-sans selection:bg-indigo-500/30 flex flex-col overflow-hidden">
      <AmbientBackground />
      
      <div className="flex-shrink-0 z-50">
        <Navbar />
      </div>

      {/* 
          CAMBIOS PARA SUBIR LA TARJETA:
          1. justify-center: Centra verticalmente.
          2. pb-12 md:pb-20: Agrega padding abajo extra para "empujar" la tarjeta hacia arriba visualmente.
      */}
      <main className="flex-1 flex items-center justify-center px-4 pb-12 md:pb-20 relative">
        
        <div className="w-full max-w-sm relative z-10"> {/* max-w-sm para hacerla más estrecha y estilizada */}
          
          {/* TARJETA MÁS COMPACTA (p-6 en lugar de p-10) */}
          <div className="rounded-[2rem] border border-white/10 bg-[#0F0F0F]/80 backdrop-blur-xl shadow-2xl overflow-hidden relative p-6 md:p-8">
            
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-indigo-500/50 to-transparent opacity-60" />

            {/* Encabezado Compacto */}
            <div className="text-center mb-5"> 
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500/20 to-violet-500/10 border border-indigo-500/20 shadow-[0_0_15px_rgba(99,102,241,0.2)] mb-3 group">
                <Lock className="w-5 h-5 text-indigo-400 group-hover:scale-110 transition-transform duration-500" />
              </div>
              
              <h1 className="text-xl font-bold text-white tracking-tight mb-1">
                Bienvenido
              </h1>
              <p className="text-white/50 text-[10px] md:text-xs leading-relaxed max-w-xs mx-auto">
                Accede al panel de control.
              </p>
            </div>

            {/* Formulario */}
            <div className="mb-5"> 
              <LoginForm />
            </div>

            {/* Footer Links Compacto */}
            <div className="space-y-2 text-center border-t border-white/5 pt-3">
              <Link
                to="/recuperar-password"
                className="block text-[10px] font-bold uppercase tracking-widest text-indigo-400 hover:text-indigo-300 transition-colors"
              >
                ¿Olvidaste tu contraseña?
              </Link>
              
              <p className="text-[10px] text-white/40">
                ¿Sin cuenta?{' '}
                <Link 
                  to="/registro" 
                  className="text-white hover:text-indigo-300 font-bold transition-colors ml-1 inline-flex items-center gap-1"
                >
                  Regístrate <ArrowRight className="w-3 h-3" />
                </Link>
              </p>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}